import Marionette from "backbone.marionette";
import UsersTpl from "views/users/usersView.ejs";
import InsertUser from "views/users/insertUserView.js";
import PaginationView from "views/pagination/pagination.js";

import PermissionsCollection from "collections/permissionsCollection.js";
import SectionsCollection from "collections/sectionsCollection.js";
import UserModel from "models/userModel.js";

import CSS from "views/users/users.css";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    initialize: function() {
        this.listenTo(S.mApp, "update:users", function(ev) {
            this.collection.fetch({
                data: {
                    page: 1,
                    company: S.companyId
                },
                beforeSend: T.useToken
            });
        });


        this.listenTo(this.collection, "request", function() {
            $("#loaderContainer").show();
        });
        this.listenTo(this.collection, "destroy", this.applyView.bind(this));
        this.listenTo(this.collection, "sync", this.applyView.bind(this));

        this.listenTo(S.mApp, "next", this.next.bind(this));
        this.listenTo(S.mApp, "prev", this.prev.bind(this));
        this.listenTo(S.mApp, "page", this.page.bind(this));
    },
    template: UsersTpl,
    render: function() {
        //Solo válido para superAdmin

        this.collection.fetch({
            data: {
                page: 1,
                company: S.companyId
            },
            beforeSend: T.useToken,
            success: function() {

                this.$el.html(this.template({
                    lang: this.collection.lang,
                    role_user: S.userInfo.attributes.role
                }));
            }.bind(this)
        });

    },
    applyView: function() {
        var data = [];

        _.each(this.collection.models, function(model) {

            ////solo visualizo usuarios gestores y usuarios normales. 
            if (model.attributes.role > 1) {

                var role;
                switch (model.attributes.role) {
                    case "0":
                        role = "Super Administrador";
                        break;
                    case "1":
                        role = "Consultor Admin <--NO VISIBLE-->"
                        break;
                    case "2":
                        role = "GESTOR";
                        break;
                    case "3":
                        role = "USUARIO NORMAL";
                        break;
                }




                var userAction = '**';
                /////SOLO NOSOTROS... PODEMOS MODIFICAR COSAS. 
                if (S.userInfo.attributes.role < 3) {

                    userAction = '<div class="unbreakable">' +
                        '<div  class="cont_doos_li"><span class="ion ion-ios-compose text-light-blue" id="edit"><b class="lb_tit_oo"> Modificar</b>&nbsp;</span> <br></div>';
                    if (model.attributes.role > 1) {
                        ///// GESTOR Y USUARIO NORMAL EDITAR QUE ES LO QUE PUEDEN VER. 
                        userAction = userAction + '<div  class="cont_doos_li"><span class="ion ion-ios-unlocked text-yellow" id="permission"><b  class="lb_tit_oo" > Permisos</b>&nbsp; </span> <br></div>';
                    }

                    /////SOLO EL USUARIO NORMAL
                    if (model.attributes.role > 2) {
                        ///// GESTOR Y USUARIO NORMAL EDITAR QUE ES LO QUE PUEDEN VER. 
                        userAction = userAction + '<div  class="cont_doos_li"><span class="icon ion ion-android-folder-open  text-yellow" id="sections_i"><b  class="lb_tit_oo" > Secciones</b>&nbsp; </span> <br></div>';
                    }

                    userAction = userAction + '<div class="cont_doos_li" ><span class="ion ion-ios-close text-red deleteUser" id="delete"><b  class="lb_tit_oo" > Borrar</b></span></div>' +
                        '</div>';
                }

                data.push({
                    id: model.attributes.id,
                    username: model.attributes.username,
                    first_name: model.attributes.first_name,
                    last_name: model.attributes.last_name,
                    department: model.attributes.department,
                    language: model.attributes.language,
                    role: role,
                    action: userAction
                });
            }
        });

        $("#userData").bootstrapTable({
            striped: true,
            sidePagination: 'server',
            columns: [{
                field: 'id',
                title: 'User ID',
                class: "hidden"
            }, {
                field: 'username',
                title: 'Email',
                sortable: true
            }, {
                field: 'first_name',
                title: this.collection.lang.NAME,
                sortable: true
            }, {
                field: 'last_name',
                title: this.collection.lang.LAST_NAME,
                sortable: true
            }, {
                field: 'language',
                title: this.collection.lang.LANGUAGE
            }, {
                field: 'role',
                title: this.collection.lang.ROLE
            }, {
                field: 'department',
                title: this.collection.lang.DEPARTMENT
            }, {
                field: 'action',
                title: this.collection.lang.ACTION
            }],
        });

        $("#userData").bootstrapTable("removeAll");
        $("#userData").bootstrapTable("append", data);

        $("#userData").off("sort.bs.table").on("sort.bs.table", function(ev, $param1, $param2) {
            var page = parseInt($(".pagination li.active").attr("id").split("-")[1]);

            this.searchService(page, {
                column: $param1,
                order: $param2
            });
        }.bind(this));

        this.pagination.show(new PaginationView({
            attributes: this.collection.pageAttributes
        }));

        // Show usuarios y entornos
        $("a#USERS, a#ENVIRO").parent().show();

        $("body").removeClass().addClass("hold-transition skin-black fixed sidebar-mini");
        $(".main-sidebar").show();

        $("#loaderContainer").hide();
        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li > ul").removeClass("menu-open");
        // Add active menu items
        $("#USERS").parent().addClass("active");

    },
    events: {
        "click #addUser": "addUser",
        "click #cancel": "cancel",
        "click #edit": "edit",
        "click #permission": "permission",
        "click #sections_i": "sections_i",
        "click .deleteUser": "delete",
        "keyup #search": "searchWord"
    },
    addUser: function() {
        S.mApp.trigger("modal", {
            view: new InsertUser({
                model: new UserModel(),
                collection: this.collection,
                role: S.userInfo.attributes.role,
                role_user: S.userInfo.attributes.role
            })
        });
    },
    searchService: function(page, params) {
        var data = {};
        var searchItems = $(".search");

        $.each(searchItems, function() {
            if ($(this).val())
                data[$(this).attr("name")] = $(this).val();
        });

        data.page = page || 1;
        data.company = S.companyId;

        if (params && params.column) {
            data.column = params.column;
            data.order = params.order;
        }

        if (params && params.search) {
            data.search = params.search;
            data.fields = "first_name, last_name, username";
        }

        this.collection.fetch({
            data: data,
            beforeSend: T.useToken
        });
    },
    searchWord: function(ev) {
        var text = $(ev.target).val();
        if (!text.length) {
            this.searchService(1);
        }

        if (text.length > 4) {
            this.searchService(1, {
                search: text
            });
        }
    },
    edit: function(ev) {
        var userId = $(ev.target).parents("tr").find("td:first-child").html();

        S.mApp.trigger("modal", {
            view: new InsertUser({
                model: this.collection.get(userId),
                collection: this.collection,
                available: this.collection.available,
                role: S.userInfo.attributes.role
            })
        });
    },
    delete: function(ev) {
        ev.preventDefault();
        var thisAlias = this;
        $(ev.currentTarget).confirmation({
            rootSelector: ".deleteUser",
            placement: 'left',
            singleton: true,
            title: S.userInfo.attributes.lang.DELETE_CONFIRM,
            popout: true,
            onConfirm: function() {
                var userId = $(ev.target).parents("tr").find("td:first-child").html();
                thisAlias.collection.get(userId).destroy({
                    beforeSend: T.useToken
                });
            },
            btnOkClass: 'btn-sm btn-danger',
            btnOkLabel: S.userInfo.attributes.lang.ACCEPT,
            btnCancelClass: 'btn-sm btn-default',
            btnCancelLabel: S.userInfo.attributes.lang.CANCEL,

        });
        $(ev.currentTarget).confirmation('show');
    },
    permission: function(ev) {
        var userId = $(ev.target).parents("tr").find("td:first-child").html();
        S.mApp.trigger("navigate", {
            to: "permissions",
            model: this.collection.get(userId),
            collection: new PermissionsCollection()
        });
    },
    /////El apartado de sections. 
    sections_i: function(ev) {


        var userId = $(ev.target).parents("tr").find("td:first-child").html();
        S.mApp.trigger("navigate", {
            to: "sectioins_v",
            model: this.collection.get(userId),
            collection: new SectionsCollection()
        });
    },
    next: function(ev) {
        ev.preventDefault();
        var nextPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) + 1;
        this.searchService(nextPage);
    },
    prev: function(ev) {
        ev.preventDefault();
        var prevPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) - 1;
        this.searchService(prevPage);
    },
    page: function(ev) {
        ev.preventDefault();
        var page = parseInt($(ev.target).parent().attr("id").split("-")[1]);
        this.searchService(page);
    },
    regions: {
        pagination: "#paginationHolder"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/users/usersView.js
// module id = 211
// module chunks = 0